import { DeviceControlDAO } from '../../../../../../data/DeviceControlDAO';
import { commonDataAccess } from '../../data/dataAccessObject';
export const rollingSchedulerDAO = {
    ...commonDataAccess,
    getRollingProgrammeContext: DeviceControlDAO.device.control.programme.rolling.getContext,
};
